<template>
  <IconLucideExternalLink />
</template>
